export default "__VITE_ASSET__D2YXpmXu__"